import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "src/components/notify/Notify";
import { currentUserHandleCache } from "src/utils/helper";
import useCurrentUserCache from "src/hooks/useCurrentUserCache";
import useAuth from "src/hooks/useAuth";
import { allowedDeployCache } from "src/constants/role";
import Controls from "src/components/form/controls/Controls";
import {
  clearCacheFLFQueryType,
  deployCacheFLFQueryType,
  getCacheFLFQueryType,
} from "src/apis/FLF/queryType.api";

const CreateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa tạo ${listDataCache.length} Query Type`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#0069A9" }}
        >
          {`${index + 1}. ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const UpdateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa cập nhật ${listDataCache.length} Query Type`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#d68102" }}
        >
          {`${index + 1}. ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const DeleteCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa xóa ${listDataCache.length} Query Type`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#fb0b12" }}
        >
          {`${index + 1}. ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const objectActionCache = {
  Create: CreateCache,
  Update: UpdateCache,
  Delete: DeleteCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheFLFQueryType = () => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheFLFQueryType((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          deployCacheFLFQueryType((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          clearCacheFLFQueryType((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Controls.Button
            sx={{
              width: "150px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "150px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheFLFQueryType;
